import type { BoxProps } from '@hover/blueprint';
import { Box } from '@hover/blueprint';
import type { Virtualizer } from '@tanstack/react-virtual';
import React from 'react';

export interface VirtualListContentProps extends BoxProps {
  children: BoxProps['children'];
  orientation?: 'horizontal' | 'vertical';
  virtualizer: Virtualizer<any, any>;
}

export const VirtualListContent = ({
  children,
  orientation = 'vertical',
  virtualizer,
  ...props
}: VirtualListContentProps) => (
  <Box
    display="block"
    height={
      orientation === 'vertical' ? `${virtualizer.getTotalSize()}px` : undefined
    }
    position="relative"
    width={
      orientation === 'horizontal'
        ? `${virtualizer.getTotalSize()}px`
        : undefined
    }
    {...props}
  >
    {children}
  </Box>
);
